import { Component } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './services/auth/auth.service';
import { UserService } from './services/user/user.service';
import { User } from './models/user-model';
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'studiomap-client';

  cutom_loading: boolean = false;

  user: any = null;
    location: any;
    routerSubscription: any;

    constructor(private router: Router, private authService: AuthService, private userService: UserService) {
    }

    ngOnInit() {

        if (this.authService.currentUserValue) {
            var is_connect_with = this.authService.currentUserValue.is_connect_with;
            var switch_account = this.authService.currentUserValue.switch_account;

            console.log("===============is_connect_with =============");
            
            console.log(is_connect_with);
            

            if(is_connect_with) {
                this.userService.getById(this.authService.currentUserValue.id,this.authService.currentUserValue.token).subscribe(user => {
                    let userJson = User.toJson(user, this.authService.currentUserValue.token,is_connect_with,switch_account);
                    if (userJson != null) {
                        localStorage.setItem('studiomapUser', JSON.stringify(userJson));
                        this.authService.callCurrentUserSubject(userJson);
                    } else {
                        this.authService.logout();
                    }
                },err=>{
                    this.authService.logout();
                });
            }else{
                this.userService.get(this.authService.currentUserValue.token).subscribe(user => {
                    let userJson = User.toJson(user, this.authService.currentUserValue.token,is_connect_with,switch_account);
                    if (userJson != null) {
                        localStorage.setItem('studiomapUser', JSON.stringify(userJson));
                        this.authService.callCurrentUserSubject(userJson);
                    } else {
                        this.authService.logout();
                    }
                },err=>{
                    this.authService.logout();
                });
            }

            
        }
        this.recallJsFuntions();

    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }

}
